import {useState } from "react";
import { AcademyContext } from "./AcademyContextDefinition";
export const AcademyProvider = ({ children }) => {
  const [search, setSearch] = useState("");
  const [toggle, setToggle] = useState("List");

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleToggle = (id) => {
    setToggle(id);
  };

  return (
    <AcademyContext.Provider
      value={{ search, handleSearch, toggle, handleToggle }}
    >
      {children}
    </AcademyContext.Provider>
  );
};
